<div class="progress-loader" [hidden]="!loading">
  <div class="spinner-border" role="status"></div>
  @if (inviting) {
    <div class="inviting-text">
      <b>
        {{ 'text.invitingHeader' | transloco }}
      </b>
      <br />
      <p>
        {{ 'text.invitingText' | transloco }}
      </p>
    </div>
  }

  @if (invitingFail) {
    <div class="inviting-text">
      <b>
        {{ 'text.invitingFailHeader' | transloco }}
      </b>
      <br />
      <p>
        {{ 'text.invitingFailText' | transloco }}
        <a [href]="'mailto:' + constants.supportEmail">{{ constants.supportEmail }}</a>
        {{ 'license.orVisit' | transloco }}
        <a [href]="constants.supportUrl" target="_blank">{{ constants.supportUrl }}</a>
        {{ 'license.forAssistance' | transloco }}
      </p>
    </div>
  }
</div>

<div class="progress-loader non-blocking" [hidden]="!loadingNonBlocking">
  <div class="spinner-border" role="status">
    <!-- <span class="sr-only">Loading...</span> -->
  </div>
</div>
